import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-black text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 
          className="text-4xl font-bold text-center mb-12"
          style={{
            background: 'linear-gradient(to right, #FF0000, #FF9900, #33CC33, #3399FF)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}
        >
          AweitFlix Terms of Service
        </h1>

        <div className="space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
            <p className="text-lg">
              By accessing or using the AweitFlix movie streaming and social media application ("Service"), 
              you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, 
              please do not use the Service. AweitFlix reserves the right to update these Terms at any time, 
              with changes effective upon posting.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">2. Eligibility</h2>
            <p className="text-lg">
              You must be at least 13 years old to use the Service. By using AweitFlix, you represent and 
              warrant that you meet this age requirement and have the legal capacity to enter into these Terms. 
              If you are under 18, you must have parental or guardian consent to use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">3. Account Registration</h2>
            <p className="text-lg">
              To access certain features of the Service, you must create an account. You agree to provide 
              accurate, current, and complete information during registration and to keep your account 
              information updated. You are responsible for maintaining the confidentiality of your account 
              credentials and for all activities that occur under your account. Notify AweitFlix immediately 
              of any unauthorized use of your account.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">4. Use of the Service</h2>
            <p className="text-lg">
              AweitFlix grants you a limited, non-exclusive, non-transferable, and revocable license to use 
              the Service for personal, non-commercial purposes, subject to these Terms. You agree not to:
            </p>
            <ul className="list-disc pl-6 text-lg">
              <li>Use the Service for any illegal or unauthorized purpose.</li>
              <li>Share, distribute, or reproduce content from the Service without permission.</li>
              <li>Engage in any activity that disrupts or interferes with the Service.</li>
              <li>Attempt to gain unauthorized access to the Service or its systems.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">5. Content Ownership and Licensing</h2>
            <p className="text-lg">
              AweitFlix owns or licenses all content provided through the Service, including movies, shows, 
              and other media ("Content"). You may not copy, modify, distribute, or create derivative works 
              from the Content without express permission. User-generated content, such as comments or posts, 
              remains your property, but you grant AweitFlix a worldwide, non-exclusive, royalty-free license 
              to use, reproduce, and display such content in connection with the Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">6. Subscriptions and Payments</h2>
            <p className="text-lg">
              Certain features of the Service require a paid subscription. By subscribing, you agree to pay 
              all applicable fees as described at the time of purchase. Subscriptions may auto-renew unless 
              canceled before the renewal date. AweitFlix may change pricing with prior notice. All payments 
              are non-refundable except as required by law.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">7. User Conduct</h2>
            <p className="text-lg">
              You agree to use the Service in a manner that is respectful and lawful. Prohibited activities 
              include, but are not limited to:
            </p>
            <ul className="list-disc pl-6 text-lg">
              <li>Posting offensive, defamatory, or harmful content.</li>
              <li>Harassing or threatening other users.</li>
              <li>Violating the intellectual property rights of others.</li>
              <li>Engaging in fraudulent or deceptive practices.</li>
            </ul>
            <p className="text-lg mt-2">
              AweitFlix reserves the right to remove content or suspend accounts that violate these Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">8. Termination</h2>
            <p className="text-lg">
              AweitFlix may suspend or terminate your access to the Service at any time, with or without 
              cause, including for violation of these Terms. Upon termination, your right to use the Service 
              will cease immediately. You may terminate your account at any time by contacting support.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">9. Intellectual Property</h2>
            <p className="text-lg">
              The Service and its associated software, designs, and trademarks are the property of AweitFlix 
              or its licensors. You may not use any AweitFlix intellectual property without prior written consent.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">10. Disclaimer of Warranties</h2>
            <p className="text-lg">
              The Service is provided "as is" and "as available" without warranties of any kind, express or 
              implied, including warranties of merchantability, fitness for a particular purpose, or 
              non-infringement. AweitFlix does not guarantee that the Service will be uninterrupted, secure, 
              or error-free.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">11. Limitation of Liability</h2>
            <p className="text-lg">
              To the fullest extent permitted by law, AweitFlix shall not be liable for any indirect, 
              incidental, special, consequential, or punitive damages arising out of or relating to your use 
              of the Service. AweitFlix’s total liability for any claim shall not exceed the amount paid by 
              you for the Service in the preceding 12 months.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">12. Governing Law and Dispute Resolution</h2>
            <p className="text-lg">
              These Terms shall be governed by the laws of the State of California, without regard to its 
              conflict of law principles. Any disputes arising under these Terms shall be resolved through 
              binding arbitration in accordance with the rules of the American Arbitration Association. 
              Arbitration shall take place in San Francisco, California.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">13. Privacy</h2>
            <p className="text-lg">
              Your use of the Service is subject to our Privacy Policy, which describes how we collect, use, 
              and protect your personal information. By using the Service, you consent to such practices as 
              outlined in the Privacy Policy.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">14. Contact Information</h2>
            <p className="text-lg">
              If you have any questions about these Terms, please contact us at:
              <br />
              Email: support@aweitflix.com
              <br />
              Address: AweitFlix Inc., 123 Streaming Way, San Francisco, CA 94105
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">15. Miscellaneous</h2>
            <p className="text-lg">
              These Terms constitute the entire agreement between you and AweitFlix regarding the Service. 
              If any provision of these Terms is found to be invalid, the remaining provisions will remain in 
              full force and effect. AweitFlix’s failure to enforce any right or provision shall not be deemed 
              a waiver of such right or provision.
            </p>
          </section>
        </div>

        <p className="text-center text-lg mt-12">
          Last Updated: April 16, 2025
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;